import * as React from 'react';
import { useSelector } from 'react-redux';

import { Disclaimer } from '../../components/Disclaimer/Disclaimer';
import {
  isShowAuctionDisclaimer,
  isShowBankDisclaimer,
  isShowDemolishedProgramDisclaimer,
  isShowElectronicTradeDisclaimer,
  isShowEncumbranceDisclaimer,
  isShowLayoutApprovedDisclaimer,
  isShowLayoutNotApprovedDisclaimer,
  selectIsApartment,
  selectIsFutureFlatRepairAfterDeal,
} from '../../selectors';
import { useApplicationContext } from '../ApplicationContext';

export const DisclaimerContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isSearchFlatShareEnabled = config.get<boolean>('frontend_search_flat_share_enabled.Enabled');

  const showAuctionDisclaimer = useSelector(isShowAuctionDisclaimer);
  const showBankDisclaimer = useSelector(isShowBankDisclaimer);
  const showDemolishedProgramDisclaimer = useSelector(isShowDemolishedProgramDisclaimer);
  const showElectronicTradeDisclaimer = useSelector(isShowElectronicTradeDisclaimer);
  const showEncumbranceDisclaimer = useSelector(isShowEncumbranceDisclaimer);
  const showLayoutApprovedDisclaimer = useSelector(isShowLayoutApprovedDisclaimer);
  const showLayoutNotApprovedDisclaimer = useSelector(isShowLayoutNotApprovedDisclaimer);
  const isApartments = useSelector(selectIsApartment);
  const isFutureFlatRepairAfterDeal = useSelector(selectIsFutureFlatRepairAfterDeal);

  return (
    <>
      {showAuctionDisclaimer && (
        <Disclaimer
          testId="auction"
          header="Аукцион"
          title="Объект реализуется посредством электронных торгов. Конечную информацию об оплате, дополнительных платежах и условия заключения договора смотрите в документах извещения к лоту, на сайте электронной торговой площадки."
        />
      )}

      {isSearchFlatShareEnabled && showLayoutApprovedDisclaimer && (
        <Disclaimer
          testId="layout-approved"
          header={`Это доля в ${isApartments ? 'апартаментах' : 'квартире'}`}
          title="Уточните у автора объявления, как оформлено право собственности и перепланировка, а также какой ремонт — можно ли заезжать и жить"
          sendAnalytics
        />
      )}

      {isSearchFlatShareEnabled && showLayoutNotApprovedDisclaimer && (
        <Disclaimer
          testId="layout-not-approved"
          header={`Это доля в ${isApartments ? 'апартаментах' : 'квартире'} с несогласованной перепланировкой`}
          title="Уточните у автора объявления, как оформлено право собственности и какой ремонт — можно ли заезжать и жить"
          sendAnalytics
        />
      )}

      {showBankDisclaimer && (
        <Disclaimer
          testId="bank"
          header="Залоговая недвижимость"
          title="Продаётся банком, которому объект перешёл из-за невыплаченного кредита или ипотеки"
        />
      )}

      {showDemolishedProgramDisclaimer && (
        <Disclaimer
          testId="demolished"
          header="Дом под снос"
          title="По результатам голосования жильцов дом включен в программу реновации и будет снесен"
        />
      )}

      {isFutureFlatRepairAfterDeal && (
        <Disclaimer
          testId="future-flat-repair-after-deal"
          header="Ремонт в процессе или запланирован"
          title="На объекте ведутся или запланированы ремонтные работы в рамках представленного в объявлении дизайн-проекта. Стоимость ремонта и мебели включены в указанную в объявлении цену. Актуальную информацию по срокам готовности, порядку оформления права собственности и другим деталям уточняйте у автора объявления"
        />
      )}

      {showElectronicTradeDisclaimer && (
        <Disclaimer
          testId="electronic-trade"
          header="Аукцион"
          title="Объект продаётся на сайте электронных торгов. В объявлении указана стартовая цена"
        />
      )}

      {showEncumbranceDisclaimer && (
        <Disclaimer
          testId="encumbrance"
          header="От банка, с обременением"
          title="Объект с обременением, подробности уточняйте по телефону"
        />
      )}
    </>
  );
};
